import React, { useState, useContext, useEffect } from "react";
import {
  Container,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { useLocation, useNavigate } from "react-router-dom";
import NavBar from "../component/NavBar";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { SnackbarContext } from "../constant/SnackbarProvider";
import HttpClient from "../api/HttpClient";
import { useLoading } from "../constant/LoadingContext";
import { useGlobalData } from "../constant/GlobalDataContext";
import ModalContainer from "../component/ModalContainer";
import StaffTableRow from "../component/StaffTableRow";

const personalInfo = require("../icons/personal_info.png");
const otherForm = require("../icons/other_form.png");
const editImage = require("../icons/edit.png");

type Props = {};

interface Column {
  id:
    | "staff_code"
    | "chinese_name"
    | "area"
    | "joinDate"
    | "staff_signature_date"
    | "brand"
    | "action";
  label: string;
  minWidth?: number;
  align?: "right";
}

const StaffTable = () => {
  const classes = useStyles();
  const [staffCode, setStaffCode] = useState("");
  const [staffJoinDate, setStaffJoinDate] = useState<Date | null>(null);
  const location = useLocation();
  const { setLoading } = useLoading();
  const { globalData, setGlobalData } = useGlobalData();
  const [open, setOpen] = useState(false);

  // const inputRef = useRef(null);
  const Snackbar = useContext(SnackbarContext);

  const searchValue = location?.state?.searchValue;

  const [tableLists, setTableLists] = useState([]);

  const navigate = useNavigate();

  const [isStaffCodeEdit, setIsStaffCodeEdit] = useState({ edit: false, id: null });
  const [isJoinDateEdit, setIsJoinDateEdit] = useState({ edit: false, id: null });
  const [updatedStaffCodeLists, setUpdatedStaffCodeLists] = useState([]);

  const columns: readonly Column[] = [
    { id: "staff_code", label: "員工編號", minWidth: 120 },
    {
      id: "joinDate",
      label: "入職日期",
      minWidth: 120,
    },
    { id: "chinese_name", label: "員工姓名", minWidth: 120 },
    {
      id: "area",
      label: "所屬位置",
      minWidth: 120,
    },
    {
      id: "brand",
      label: "公司",
      minWidth: 120,
    },
    {
      id: "staff_signature_date",
      label: "簽署日期",
      minWidth: 120,
    },
    {
      id: "action",
      label: "",
      minWidth: 60,
    },
  ];

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const isRecruitment = user?.data?.userDataFilter?.some(
    (o) => o.controlArea === "recruitment"
  );

  const isCnB = user?.data?.userDataFilter?.some(
    (o) => o.controlArea === "c&b"
  );

  const RenderAreaJudge = (v: string) => {
    return user?.data?.userDataFilter?.some((o) => o.controlValue === v);
  };

  useEffect(() => {
    const HandleSearchStaff = async () => {
      setLoading(true);
      HttpClient().HandleWebSearchStaffApi(
        { searchValue, userDataFilter: user?.data?.userDataFilter },
        (data) => {
          // const temp = data?.data?.map((o: any) => ({ ...o, expanded: false }));
          if (!!isRecruitment) {
            const onlyTodayRecord = data?.data
              ?.filter(
                (o) =>
                  !!RenderAreaJudge(o.area) &&
                  o?.staff_signature !== null
              )
              ?.map((o: any) => ({ ...o, expanded: false }));

            setTableLists(onlyTodayRecord);
          }
          if (!!isCnB) {
            const filteredData = data.data
              ?.filter(
                (o) => !!RenderAreaJudge(o.area) && o?.staff_signature !== null
              )
              ?.map((o: any) => ({ ...o, expanded: false }));
            setTableLists(filteredData);
          }

          setLoading(false);
        },
        () => {
          setLoading(false);
          setOpen(true);
        }
      );
    };
    if (searchValue !== undefined) {
      HandleSearchStaff();
    }
  }, []);

  const HandleUpdateStaffCode = async (id: any) => {
    setLoading(true);
    HttpClient().UpdateStaffCodeApi(
      { staffCode, id },
      () => {
        // Check if the staffCode already exists for the given id
        const existingIndex = tableLists.findIndex(
          (item) => item.id === id
        );

        if (existingIndex !== -1) {
          // Modify the existing record
          const updatedList = [...tableLists];
          updatedList[existingIndex] = {...updatedList[existingIndex], staff_code: staffCode}
          setTableLists(updatedList);
        } else {
          // Ensure no duplicate records for the same id
          const filteredList = tableLists.filter(
            (item) => item.id !== id
          );
          // Push the new record
          let result = [...filteredList, {...filteredList[existingIndex], staff_code: staffCode}];
          setTableLists(result);
        }

        Snackbar.open({
          alertProps: { severity: "success" },
          message: "更新員工編號成功",
        });
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        Snackbar.open({
          alertProps: { severity: "error" },
          message: "更新員工編號失敗 " + error,
        });
      }
    );
    setStaffCode("");
    setIsStaffCodeEdit({ id: null, edit: false });
  };


  const HandleUpdateStaffJoinDate = async (id: any) => {
    setLoading(true);
    HttpClient().UpdateStaffJoinDateApi(
      { staffJoinDate, id },
      () => {
        // Check if the staffCode already exists for the given id
        const existingIndex = tableLists.findIndex(
          (item) => item.id === id
        );

        if (existingIndex !== -1) {
          // Modify the existing record
          const updatedList = [...tableLists];
          updatedList[existingIndex] = {...updatedList[existingIndex], joinDate:  staffJoinDate};
          setTableLists(updatedList);
        } else {
          // Ensure no duplicate records for the same id
          const filteredList = tableLists.filter(
            (item) => item.id !== id
          );
          // Push the new record
          let result = [...filteredList, {...filteredList[existingIndex], joinDate:  staffJoinDate}];
          setTableLists(result);
        }

        Snackbar.open({
          alertProps: { severity: "success" },
          message: "更新入職日期成功",
        });
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        Snackbar.open({
          alertProps: { severity: "error" },
          message: "更新入職日期失敗 " + error,
        });
      }
    );
    setStaffJoinDate(null);
    setIsJoinDateEdit({ id: null, edit: false });
  };

  const FetchDocLists = async (row: any) => {
    const order = [
      "reference_authorization",
      "personal_information",
      "handbook",
    ];
    HttpClient().FetchDocListsApi(
      { searchValue: row?.id, userDataFilter: user?.data?.userDataFilter },
      (data) => {
        const temp = data?.data
          ?.map((item: any) => {
            return { ...item, checked: false };
          })
          ?.sort((a, b) => {
            const indexA = order.indexOf(a.document_name);
            const indexB = order.indexOf(b.document_name);
            return indexA - indexB;
          });

        const unsignDoc = data?.data?.filter((o: any) => !o.signature);
        if (unsignDoc.length === 0) {
          navigate("/main/documentLists", {
            state: {
              staffId: row?.id,
              brand: row?.brand,
              docLists: temp,
              staffData: row,
              searchValue: row?.id,
            },
          });
          setGlobalData({
            ...globalData,
            staffId: row?.id,
            brand: row?.brand,
            docLists: temp,
          });
        } else {
          setOpen(true);
        }

        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  const handleToggleExpand = (index: number) => {
    const temp = tableLists.map((o, i) => {
      if (i === index) {
        return {
          ...o,
          expanded: !o.expanded,
        };
      }
      return o;
    });
    setTableLists(temp);
  };

  return (
    <Container className={classes.container}>
      <NavBar isBack={true} />
      <ModalContainer open={open} setOpen={setOpen} type={"noSignDocument"} />
      <div style={{ backgroundColor: "#F0EFF6", minHeight: "90%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
          }}
        >
          <Paper
            style={{
              display: "flex",
              // flexDirection: "column",
              // width: "70%",
              height: "80%",
              padding: "2rem",
              borderRadius: "2rem",
            }}
          >
            <TableContainer>
              <Container style={{ padding: "10px" }} maxWidth={false}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns?.map((column, i) => (
                        <TableCell
                          key={i}
                          style={{
                            minWidth: column.minWidth,
                            color: "#84909F",
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableLists?.map((row, i) => (
                      <StaffTableRow
                        key={i}
                        row={row}
                        columns={columns}
                        index={i}
                        tableLists={tableLists}
                        isStaffCodeEdit={isStaffCodeEdit}
                        setIsStaffCodeEdit={setIsStaffCodeEdit}
                        isJoinDateEdit={isJoinDateEdit}
                        setIsJoinDateEdit={setIsJoinDateEdit}
                        setStaffCode={setStaffCode}
                        staffCode={staffCode}
                        HandleUpdateStaffCode={HandleUpdateStaffCode}
                        staffJoinDate={staffJoinDate}
                        setStaffJoinDate={setStaffJoinDate}
                        HandleUpdateStaffJoinDate={HandleUpdateStaffJoinDate}
                        FetchDocLists={FetchDocLists}
                        setGlobalData={setGlobalData}
                        globalData={globalData}
                        editImage={editImage}
                        handleToggleExpand={handleToggleExpand}
                        useStyles={useStyles}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Container>
            </TableContainer>
          </Paper>
        </div>
      </div>
    </Container>
  );
};

export default StaffTable;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
  },
  title: { color: "#454C96", fontWeight: 500 },
  container: {
    // display: "flex",
    height: "100vh",
    borderRadius: "10rem",
  },
  customPaper: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: "0px 0.5rem 0.5rem 0.5rem",
  },
  tableRowPaper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  tableRowPaperTopLeftRight: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: `
      0px -2px 4px -1px rgba(0, 0, 0, 0.2),   /* Top shadow */
      -2px 0px 4px -1px rgba(0, 0, 0, 0.2),   /* Left shadow */
      2px 0px 4px -1px rgba(0, 0, 0, 0.2),    /* Right shadow */
      0px 2px 4px -1px rgba(0, 0, 0, 0)       /* Transparent bottom shadow */
    `,
    padding: theme.spacing(2),
    marginBottom: 0, // Remove margin bottom
    borderRadius: "0px",
  },
  tableRowPaperLeftRightBottom: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: `
      0px -2px 0px rgba(0, 0, 0, 0),   /* Transparent top shadow */
      -2px 0px 4px -1px rgba(0, 0, 0, 0.2),   /* Left shadow */
      2px 0px 4px -1px rgba(0, 0, 0, 0.2),    /* Right shadow */
      0px 2px 4px -1px rgba(0, 0, 0, 0.2)     /* Bottom shadow */
    `,
    padding: theme.spacing(2),
    borderRadius: "0px",
    marginTop: 0, // Remove margin top
  },
  input: {
    margin: "2px 0px",
  },
  button: {
    margin: theme.spacing(1, 0),
  },
  editButton: {
    margin: theme.spacing(1, 0),
    backgroundColor: "#908DF2",
    height: "3rem",
    borderRadius: "12px",
    color: "#FFFFFF",
  },
  media: {
    width: "20px",
    height: "20px",
    margin: "5px",
    [`&.MuiCardMedia-img`]: {
      objectFit: "contain",
    },
  },
  arrow: {
    height: "20px",
    margin: "5px",
    cursor: "pointer",
    [`&.MuiCardMedia-img`]: {
      objectFit: "contain",
      width: "20px",
    },
  },
  adornment: {},
  imageForm: {
    width: "8rem",
    height: "6rem",
    backgroundColor: "#F4EFFF",
    display: "flex",
    justifyContent: "center",
    borderRadius: "1rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#454C96",
    },
    alignItems: "center",
    flexDirection: "column",
  },
}));
